class WishlistCheckboxes {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.checkboxesToggle = self.elem.querySelector('[data-collections-checkbox-toggle]');
        self.checkboxWrappers = self.elem.querySelectorAll('[data-collection-checkbox-wrapper]');
        self.itemsEndpoint = '/index.php?p=actions/site/wishlist/list-items';
        self.checkboxesVisible = false;
    }

    init() {
        let self = this;

        self.setCheckboxes();

        // Toggle checkboxes visibility
        if(self.checkboxesToggle) {
            self.checkboxesToggle.addEventListener('click', evt => {
                if(self.checkboxesVisible) {
                    self.hideCheckboxes();
                } else {
                    self.showCheckboxes();
                }
            });
        }
    }

    setCheckboxes() {
        let self = this;

        fetch(self.itemsEndpoint, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (data) {
            if(data.items.length > 0) {
                if (data.response === 'success') {

                    let checkboxes = self.elem.querySelectorAll('[data-wishlist-checkbox]');

                    [...checkboxes].map(checkbox => {
                        let id = checkbox.getAttribute('data-wishlist-checkbox');
                        
                        if(data.items.some(item => parseInt(item.elementId) === parseInt(id))) {
                            checkbox.checked = true;
                        }
                    });

                }
            }

        }).catch(function (err) {
            // There was an error
            console.warn('Could not fetch wishlist count', err);
        });
    }

    showCheckboxes() {
        let self = this;

        [...self.checkboxWrappers].map(item => {
            item.classList.add('is-visible');

            // Force a re-paint
            let reflow = item.offsetHeight;

            item.classList.add('is-active');
        });

        self.checkboxesToggle.setAttribute('aria-expanded', true);

        self.checkboxesVisible = true;
    }

    hideCheckboxes() {
        let self = this;

        [...self.checkboxWrappers].map(item => {
            item.classList.remove('is-active');

            // Function to remove is-visible class from element once slide transition is complete
            let func = function() {
                item.classList.remove('is-visible');
                item.removeEventListener('transitionend', func);
            }

            item.addEventListener('transitionend', func, false);
        });

        self.checkboxesToggle.setAttribute('aria-expanded', false);

        self.checkboxesVisible = false;
    }
}

export default WishlistCheckboxes;
